import React from 'react';
import {render, hydrate} from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {DataProvider} from 'globals/contexts/dataContext';
// import ReactDOMServer from 'react-dom/server';
import './index.css';
import App from './App';
// import * as serviceWorker from './serviceWorker';

const initialState = {
  currentActiveContent: 0,
  menuIsActive: false,
  currentLanguage: window.__PRELOADED_STATE__['language'][0]['code'],
  content: window.__PRELOADED_STATE__
};

// https://developer.mozilla.org/en-US/docs/Web/API/History/scrollRestoration
if (window && window.history && window.history.scrollRestoration) {
  // disable auto restore scroll position
  window.history.scrollRestoration = 'manual';
}
const main = document.getElementById('main');
if (main.hasChildNodes()) {
  hydrate(
    <DataProvider initialState={initialState}>
      <BrowserRouter basename={`/`}>
        <App />
      </BrowserRouter>
    </DataProvider>
  ,
  main,
  ()=>{
    console.log('hydrated');
  });
} else {
  render(
    <DataProvider initialState={initialState}>
      <BrowserRouter basename={`/`}>
        <App />
      </BrowserRouter>
    </DataProvider>
  ,
  main,
  ()=>{
    console.log('render');
  });
}


// console.log(ReactDOMServer.renderToString(<App />));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
// serviceWorker.register();
